<template>
  <BaseDialog
    ref="dialog"
    contentClass="tenders-filters-dialog"
    sidePanel
    :show-actions="true"
    :persistent="false"
    :on-close="closeDialog"
    @closeModal="closeDialog"
    @dialog-closed="closeDialog"
  >
    <template slot="title">{{ $t('page.tenders.views.filters.compact-title') }}</template>
    <template slot="content">
      <TendersFiltersChips
        stacked
        :search-filters="searchFilters"
        :platforms="platforms"
        :users="users"
        :seao-active="seaoActive"
        :scoring-eligible="scoringEligible"
        :keywords-active="keywordsActive"
        :zones-active="zonesActive"
        :zones-badge="zonesBadge"
        :archived-active="archivedActive"
        v-on="$listeners"
      />
    </template>
    <template slot="actions">
      <div class="tenders-filters-dialog__actions">
        <BaseButton isTransparent isUnderline isSquare :disabled="!hasActiveFilters" @click.native="$emit('clear-all')">
          {{ $t('filters.clear-all') }}
        </BaseButton>
        <BaseButton @click.native="closeDialog">{{ $t('filters.done') }}</BaseButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseButton from '@/components/base/BaseButton';
import BaseDialog from '@/components/base/BaseDialog';
import TendersFiltersChips from '@/components/page-tenders/views/TendersFiltersChips.vue';

/**
 * Compact (tablet/mobile) filters drawer — stacks every tenders filter chip and re-emits the same
 * dimension events as the desktop chip row.
 */
export default {
  name: 'TendersFiltersDialog',
  components: { BaseButton, BaseDialog, TendersFiltersChips },
  props: {
    searchFilters: { type: Object, required: true },
    platforms: { type: Array, default: () => [] },
    users: { type: Array, default: () => [] },
    seaoActive: { type: Boolean, default: false },
    scoringEligible: { type: Boolean, default: false },
    keywordsActive: { type: Boolean, default: false },
    zonesActive: { type: Boolean, default: false },
    zonesBadge: { type: String, default: '' },
    archivedActive: { type: Boolean, default: false },
    hasActiveFilters: { type: Boolean, default: false },
  },
  methods: {
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
      this.$emit('close');
    },
  },
  mounted() {
    this.$nextTick(() => this.$refs.dialog.openModal());
  },
};
</script>

<style lang="scss">
.base-dialog__tenders-filters-dialog {
  width: min(420px, 100vw);
  max-width: 100%;

  .base-dialog__header {
    border-bottom: 1px solid $color-border;
  }

  .base-dialog__header + .base-dialog__content {
    background-color: $color-white;
    padding: 20px 24px;
  }

  .base-dialog__actions {
    padding: 16px 24px;
    border-top: 1px solid $color-border;
  }
}

.tenders-filters-dialog {
  &__actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
}
</style>
